var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpDskWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "7px",
    viewBox: "0 0 12 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrowUpDsk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.01622069,3.16218148 L8.83692227,-0.698673175 C8.94212566,-0.804725854 9,-0.946520997 9,-1.09771319 C9,-1.24898931 8.94212566,-1.39070053 8.83692227,-1.496921 L8.50213139,-1.83504785 C8.39709405,-1.9414361 8.25668449,-2 8.10705816,-2 C7.95743188,-2 7.81718837,-1.9414361 7.71206803,-1.83504785 L3.16291391,2.76163123 C3.05737836,2.86818732 2.99958707,3.01056974 3,3.16192977 C2.99958707,3.313961 3.05729531,3.45617564 3.16291391,3.56281559 L7.7078333,8.15504785 C7.81295369,8.2614361 7.9531972,8.32 8.10290653,8.32 C8.25253281,8.32 8.39277632,8.2614361 8.49797971,8.15504785 L8.83268759,7.816921 C9.05048433,7.59684489 9.05048433,7.23858149 8.83268759,7.01858931 L5.01622069,3.16218148 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "arrowUpDsk",
    fill: "#fff",
    fillRule: "nonzero",
    transform: "translate(6.000000, 3.160000) scale(-1, 1) rotate(-90.000000) translate(-6.000000, -3.160000) ",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpDskWhite);
export default __webpack_public_path__ + "static/media/arrowUpDskWhite.e46b2339c8b3886d6136de18c578138a.svg";
export { ForwardRef as ReactComponent };